export class NativeStreamProbeFilterReport {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "droppedRowIndexes",
            "baseName": "droppedRowIndexes",
            "type": "Array<number>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamProbeFilterReport.attributeTypeMap;
    }
    constructor() {
    }
}
